import React, { useState, useLayoutEffect, useCallback } from 'react'
import api from '../api'

import { Button, Input, Space, Table, Alert, Typography, message, Select, Modal, Tag } from 'antd'

import { ProCard, CheckCard } from '@ant-design/pro-components'

const { Title, Paragraph, Text } = Typography
const { Search } = Input



let timeoutId = false

//  控制台-订单中心 [配置]
function OrderAdmin(props) {
    const [data, setData] = useState({ total: 0, Data: [], Types: [], userConfig: {} })
    const [loading, setLoading] = useState(false)
    const [fc, setFc] = useState(undefined)
    const [type, setType] = useState(undefined)
    const [page, setPage] = useState({
        current: 1,
        pageSize: 10,
    })
    const [details, setDetails] = useState({ modal: null, name: 'give_ros' })

    //  表格
    const columns = [
        {
            title: '订单ID',
            dataIndex: '_id',
            key: '_id',
        },
        {
            title: '产品类型',
            dataIndex: 'label',
            key: 'label',
            render: ((label) => {
                return (
                    <>{label}</>
                )
            })
        },
        {
            title: '套餐',
            dataIndex: 'PlansObj',
            key: 'PlansObj',
            render: ((PlansObj) => {
                return (
                    <>{PlansObj.chinese} #{PlansObj.duration}个月</>
                )
            })
        },
        {
            title: '买家NID',
            dataIndex: 'user_nid',
            key: 'user_nid',
        },
        {
            title: '状态',
            dataIndex: 'state',
            key: 'state',
            render: ((state) => {
                let Data = parseInt(state)
                if (Data === 0) {
                    return (
                        <Tag color="warning">待处理</Tag>
                    )
                }
                if (Data === 1) {
                    return (
                        <Tag color="processing">已锁定, 人工正在开通</Tag>
                    )
                }
                if (Data === 101) {
                    return (
                        <Tag color="processing">已锁定, 系统正在开通</Tag>
                    )
                }
                if (Data === 102 || Data === 103 || Data === 104) {
                    return (
                        <Tag color="warning">系统无法处理, 等待人工介入 code:{Data}</Tag>
                    )
                }
                if (Data === 2) {
                    return (
                        <Tag color="success">已开通</Tag>
                    )
                }
                if (Data === 3) {
                    return (
                        <Tag color="error">已退款</Tag>
                    )
                }
            }),
        },

        {
            title: '实付金额',
            dataIndex: 'PlansObj',
            key: 'PlansObj',
            render: ((PlansObj) => {
                return (
                    <>{PlansObj.price}</>
                )
            })
        },
        {
            title: '发货时间',
            dataIndex: 'etime',
            key: 'etime',
        },
        {
            title: '创建时间',
            dataIndex: 'ctime',
            key: 'ctime',
        },

        {
            title: '操作',
            dataIndex: '_id',
            key: '_id',
            render: ((_id, _) => {
                let Data = parseInt(_.state)
                if (Data === 0) {
                    return (
                        <>
                            <Button size='small' onClick={() => { onClick('order_set', { _id: _id, state: '1' }) }}>锁单</Button>
                            <Button type="primary" size='small' onClick={() => { onClick('order_set', { _id: _id, state: '3' }) }} danger>退款</Button>
                        </>
                    )
                }
                if (Data === 1) {
                    return (
                        <>
                            <Button type="primary" size='small' onClick={() => { onClick('order_set', { _id: _id, state: '2' }) }}>已开通</Button>
                            <Button type="primary" size='small' onClick={() => { onClick('order_set', { _id: _id, state: '3' }) }} danger>退款</Button>
                        </>
                    )
                }

                return (
                    <>
                        <Button type="primary" size='small' onClick={() => { onClick('order_set', { _id: _id, state: '3' }) }} danger>退款</Button>
                    </>
                )
            })
        },
    ];

    useLayoutEffect(() => {
        api.post('/api/v2/pay_v2', {
            type: 'get_users_order',
            params: {
                range: page.current,
                max: page.pageSize,
            }
        })
            .then((res) => {
                if (res.data.code === 200) {
                    let Data = res.data.data.data.Data
                    console.log(Data);
                    setData(Data)
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [])

    //  异步请求拉取并更新数据
    const asyncUpdateData = useCallback((data, fcData, typeData, refresh) => {
        let Data = data ? data : page
        let Fc = fcData ? fcData : fc
        let Type = typeData ? typeData : typeData === 0 ? typeData : type

        setLoading(true)
        api.post('/api/v2/pay_v2', {
            type: 'get_users_order',
            params: {
                range: Data.current,
                max: Data.pageSize,
                fc: Fc,
                type: Type,
                refresh: refresh,
            }
        })
            .then((res) => {
                if (res.data.code === 200) {
                    let Data = res.data.data.data.Data
                    setData(Data)
                    setLoading(false)
                    timeoutId = false
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [page, fc])

    const onSearch = ((value) => {
        setFc(value)
        asyncUpdateData({
            current: 1,
            pageSize: 10,
        }, value ? value : 'undefined')
    })

    function handleChange(value) {
        setType(value)
        asyncUpdateData(null, null, value)
    }

    //  监听操作
    function onClick(name, value) {
        if (name === 'add_yes') {
            api.post('/api/v2/pay_v2', {
                type: 'add_product',
                nid: details.nid,
                name: details.name,
                url: details.url,
                instance_id: parseInt(details.instance_id),
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        asyncUpdateData()
                        setDetails({ ...details, modal: null })
                        message.success('成功添加')
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器')
                })
        }

        if (name === 'order_set') {
            api.post('/api/v2/pay_v2', {
                type: 'order_set',
                value: value,
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        asyncUpdateData()
                        setDetails({ ...details, modal: null })
                        message.success('操作成功!')
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器')
                })
        }
    }

    return (
        <div>
            <Search
                placeholder="搜索订单ID"
                onSearch={onSearch}
                style={{
                    width: 260,
                    float: 'right',
                    marginBottom: 20
                }}
            />
            <Select
                placeholder='选择状态'
                style={{
                    float: 'right',
                    width: 120,
                    marginBottom: 20,
                    marginRight: 10
                }}
                onChange={handleChange}
                options={data.Types}
            />

            <Button onClick={() => { setDetails({ ...details, modal: 'add' }) }} type="primary" style={{ float: 'right', marginBottom: 20, marginRight: 10 }} >添加产品绑定</Button>

            <props.clear />
            <Title level={4}>订单列表</Title>
            <Table
                columns={columns}
                dataSource={data.Data}
                loading={loading}
                pagination={{
                    total: data.total,
                    current: page.current,
                    pageSize: page.pageSize,
                    showSizeChanger: 20,
                    pageSizeOptions: [10, 20, 50, 100],
                    showTotal: (total) => {
                        return '总计 ' + total + ' 条数据'
                    },
                    onShowSizeChange: (current, size) => {
                        if (timeoutId) {
                            return
                        }
                        setPage({
                            current: current,
                            pageSize: size,
                        })
                        timeoutId = true
                        asyncUpdateData({ current: current, pageSize: size, })
                    },
                    onChange: (page, pageSize) => {
                        if (timeoutId) {
                            return
                        }
                        setPage({
                            current: page,
                            pageSize: pageSize,
                        })
                        timeoutId = true
                        asyncUpdateData({ current: page, pageSize: pageSize, })
                    }
                }}
            // onRow={(record) => {
            //     return {
            //         onClick: onClick, // 点击
            //     }
            // }}
            />


            <div>
                <Modal
                    title="添加产品绑定"
                    centered
                    open={details.modal === 'add'}
                    onOk={() => { onClick('add_yes') }}
                    onCancel={() => { setDetails({ ...details, modal: null }) }}
                >
                    <Space direction="vertical" >
                        <div>
                            <Select
                                value={details.name}
                                onChange={(value) => { setDetails({ ...details, name: value }) }}
                                style={{ width: 120 }}
                                options={[
                                    { value: 'give_ros', label: '存储块' },

                                ]}
                            />
                        </div>

                        <Input placeholder="用户ID" style={{ marginTop: 10 }} name='nid' onChange={(e) => { setDetails({ ...details, nid: e.target.value }) }} value={details.nid} />
                        <Input placeholder="产品ID" style={{ marginTop: 10 }} name='instance_id' onChange={(e) => { setDetails({ ...details, instance_id: e.target.value }) }} value={details.instance_id} />
                        <Input placeholder="绑定域名" style={{ marginTop: 10 }} name='url' onChange={(e) => { setDetails({ ...details, url: e.target.value }) }} value={details.url} />
                    </Space>
                </Modal>
            </div>
        </div>
    )
}

export default OrderAdmin;